import React from 'react';
import { useTranslation } from 'react-i18next';
import ComingSoon from './ComingSoon';

const AuthSecurity = () => {
  const { t } = useTranslation();
  return <ComingSoon title={t('settings.menu.authSecurity')} />;
};

export default AuthSecurity;
